import tw from "twin.macro";

export const tooltipCss = tw`inline-block w-auto`;

const light = tw`p-3 text-black bg-athensGray text-sm rounded-2xl shadow-lg whitespace-pre-wrap`;

export const THEMES = {
  light,
};
